
export default {
  head() {
    return {
      title: "Agence Google Ads | SEA à Limoges dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads à Limoges certifiée Google Partner, accompagne les entreprises limougeaudes pour développer leur visibilité en ligne et attirer plus de clients.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Agence Google Ads à Limoges dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads à Limoges certifiée Google Partner, accompagne les entreprises limougeaudes pour développer leur visibilité en ligne et attirer plus de clients.",
        },
      ],
    };
  },
};
